import { AreaInfo } from "@/apis/area";
import { ShopInfo } from "@/utils/shop";

const DefaultPrefecture = {
  TOKYO: "東京都",
  KANAGAWA: "神奈川県",
  CHIBA: "千葉県",
  SAITAMA: "埼玉県",
  AICHI: "愛知県",
  KYOTO: "京都府",
  OSAKA: "大阪府",
  HYOGO: "兵庫県",
  NARA: "奈良県",
  FUKUOKA: "福岡県",
  HOKKAIDO: "北海道",
  MIYAGI: "宮城県",
  HIROSHIMA: "広島県",
} as const;

export const Prefecture = {
  HOKKAIDO: "北海道",
  AOMORI: "青森県",
  IWATE: "岩手県",
  MIYAGI: "宮城県",
  AKITA: "秋田県",
  YAMAGATA: "山形県",
  FUKUSHIMA: "福島県",
  IBARAKI: "茨城県",
  TOCHIGI: "栃木県",
  GUMMA: "群馬県",
  SAITAMA: "埼玉県",
  CHIBA: "千葉県",
  TOKYO: "東京都",
  KANAGAWA: "神奈川県",
  NIIGATA: "新潟県",
  TOYAMA: "富山県",
  ISHIKAWA: "石川県",
  FUKUI: "福井県",
  YAMANASHI: "山梨県",
  NAGANO: "長野県",
  GIFU: "岐阜県",
  SHIZUOKA: "静岡県",
  AICHI: "愛知県",
  MIE: "三重県",
  SHIGA: "滋賀県",
  KYOTO: "京都府",
  OSAKA: "大阪府",
  HYOGO: "兵庫県",
  NARA: "奈良県",
  WAKAYAMA: "和歌山県",
  TOTTORI: "鳥取県",
  SHIMANE: "島根県",
  OKAYAMA: "岡山県",
  HIROSHIMA: "広島県",
  YAMAGUCHI: "山口県",
  TOKUSHIMA: "徳島県",
  KAGAWA: "香川県",
  EHIME: "愛媛県",
  KOCHI: "高知県",
  FUKUOKA: "福岡県",
  SAGA: "佐賀県",
  NAGASAKI: "長崎県",
  KUMAMOTO: "熊本県",
  OITA: "大分県",
  MIYAZAKI: "宮崎県",
  KAGOSHIMA: "鹿児島県",
  OKINAWA: "沖縄県",
} as const;

export enum PrefectureEnum {
  "北海道" = 1,
  "青森県" = 2,
  "岩手県" = 3,
  "宮城県" = 4,
  "秋田県" = 5,
  "山形県" = 6,
  "福島県" = 7,
  "茨城県" = 8,
  "栃木県" = 9,
  "群馬県" = 10,
  "埼玉県" = 11,
  "千葉県" = 12,
  "東京都" = 13,
  "神奈川県" = 14,
  "新潟県" = 15,
  "富山県" = 16,
  "石川県" = 17,
  "福井県" = 18,
  "山梨県" = 19,
  "長野県" = 20,
  "岐阜県" = 21,
  "静岡県" = 22,
  "愛知県" = 23,
  "三重県" = 24,
  "滋賀県" = 25,
  "京都府" = 26,
  "大阪府" = 27,
  "兵庫県" = 28,
  "奈良県" = 29,
  "和歌山県" = 30,
  "鳥取県" = 31,
  "島根県" = 32,
  "岡山県" = 33,
  "広島県" = 34,
  "山口県" = 35,
  "徳島県" = 36,
  "香川県" = 37,
  "愛媛県" = 38,
  "高知県" = 39,
  "福岡県" = 40,
  "佐賀県" = 41,
  "長崎県" = 42,
  "熊本県" = 43,
  "大分県" = 44,
  "宮崎県" = 45,
  "鹿児島県" = 46,
  "沖縄県" = 47,
}

export const switchPrefectureCode = (pref: IPrefecture) => {
  switch (pref) {
    case Prefecture.HOKKAIDO:
      return 1;
    case Prefecture.AOMORI:
      return 2;
    case Prefecture.IWATE:
      return 3;
    case Prefecture.MIYAGI:
      return 4;
    case Prefecture.AKITA:
      return 5;
    case Prefecture.YAMAGATA:
      return 6;
    case Prefecture.FUKUSHIMA:
      return 7;
    case Prefecture.IBARAKI:
      return 8;
    case Prefecture.TOCHIGI:
      return 9;
    case Prefecture.GUMMA:
      return 10;
    case Prefecture.SAITAMA:
      return 11;
    case Prefecture.CHIBA:
      return 12;
    case Prefecture.TOKYO:
      return 13;
    case Prefecture.KANAGAWA:
      return 14;
    case Prefecture.NIIGATA:
      return 15;
    case Prefecture.TOYAMA:
      return 16;
    case Prefecture.ISHIKAWA:
      return 17;
    case Prefecture.FUKUI:
      return 18;
    case Prefecture.YAMANASHI:
      return 19;
    case Prefecture.NAGANO:
      return 20;
    case Prefecture.GIFU:
      return 21;
    case Prefecture.SHIZUOKA:
      return 22;
    case Prefecture.AICHI:
      return 23;
    case Prefecture.MIE:
      return 24;
    case Prefecture.SHIGA:
      return 25;
    case Prefecture.KYOTO:
      return 26;
    case Prefecture.OSAKA:
      return 27;
    case Prefecture.HYOGO:
      return 28;
    case Prefecture.NARA:
      return 29;
    case Prefecture.WAKAYAMA:
      return 30;
    case Prefecture.TOTTORI:
      return 31;
    case Prefecture.SHIMANE:
      return 32;
    case Prefecture.OKAYAMA:
      return 33;
    case Prefecture.HIROSHIMA:
      return 34;
    case Prefecture.YAMAGUCHI:
      return 35;
    case Prefecture.TOKUSHIMA:
      return 36;
    case Prefecture.KAGAWA:
      return 37;
    case Prefecture.EHIME:
      return 38;
    case Prefecture.KOCHI:
      return 39;
    case Prefecture.FUKUOKA:
      return 40;
    case Prefecture.SAGA:
      return 41;
    case Prefecture.NAGASAKI:
      return 42;
    case Prefecture.KUMAMOTO:
      return 43;
    case Prefecture.OITA:
      return 44;
    case Prefecture.MIYAZAKI:
      return 45;
    case Prefecture.KAGOSHIMA:
      return 46;
    case Prefecture.OKINAWA:
      return 47;
    default:
      throw new Error("Illegal Prefecture.");
  }
};

export type IPrefecture = typeof Prefecture[keyof typeof Prefecture];

export const defaultPrefs: AreaInfo[] = Object.values(DefaultPrefecture).map(value => ({
  name: value,
  id: switchPrefectureCode(value),
}));

export const prefs: AreaInfo[] = Object.values(Prefecture).map(value => ({
  name: value,
  id: switchPrefectureCode(value),
}));

export const prefectureOptions: Option[] = Object.values(Prefecture).map(value => ({
  label: value,
  value,
}));

export const getShopRelatedPrefectureOptions = (shops: ShopInfo[], contractId: number): Option[] => {
  const set = new Set();
  const map = new Map();
  map.get;
  const shopRelatedPrefectures: Option[] = [];
  shops.forEach(shop => {
    if (shop.prefId && shop.contractId === contractId) {
      set.add(shop.prefId);
    }
  });
  Object.values(Prefecture).forEach(value => {
    if (set.has(switchPrefectureCode(value))) {
      if (!map.get(switchPrefectureCode(value))) {
        map.set(switchPrefectureCode(value), value);
        shopRelatedPrefectures.push({
          label: value,
          value,
        });
      }
    }
  });
  return shopRelatedPrefectures;
};

export default Prefecture;
